module.exports = __webpack_public_path__ + "img/ep6-4.95e6a078.png";